import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Combobox } from "@opala-ds/react";
import { Controller, useFormContext } from "react-hook-form";
import { useGetCitiesByUf } from "../../queries/ibge";
export default function EducationalInstitutionCitySelect(_a) {
    var defaultValue = _a.defaultValue;
    var _b = useFormContext(), control = _b.control, setValue = _b.setValue, errors = _b.formState.errors;
    var _c = useGetCitiesByUf("PI"), data = _c.data, isFetching = _c.isFetching;
    useEffect(function () {
        if (!defaultValue)
            return;
        setValue("municipio", defaultValue);
    }, [defaultValue, setValue]);
    return (_jsx(Controller, { control: control, name: "municipio", render: function (_a) {
            var _b, _c;
            var field = _a.field;
            return (_jsx(Combobox, { label: "Munic\u00EDpio", placeholder: field.value !== "" ? field.value : "Selecione", containerClassName: field.value && "[&>button>div]:text-[#262626]", defaultValue: defaultValue, value: field.value, onSelectValue: function (value) {
                    field.onChange(value);
                    var selectedCity = data === null || data === void 0 ? void 0 : data.find(function (city) { return value === city.value; });
                    if (selectedCity)
                        setValue("municipio", selectedCity.label);
                }, disabled: isFetching, items: data, helperText: (_c = (_b = errors.municipio) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "", variant: errors.municipio ? "critical" : "default" }));
        } }));
}
